import React, { Component } from 'react'
import {
  Button,
  Col,
  DatePicker,
  Form,
  Icon,
  Input,
  InputNumber,
  message,
  Popconfirm,
  Row,
  Select,
  Upload,
} from 'antd'
import Employees from '../../../../../api/Employees'
import Banks from '../../../../../api/Banks'
import CountrySelect from '../../../../../elements/Select/Country'
import { streamUrl } from '../../../../../variables/index'
import moment from 'moment'
import { get, omit, pick, set } from 'lodash'
import Authentication from '../../../../../modules/Authentication'
import CurrencySelect from '../../../../../elements/Select/Currency'
import withSelectFetch from '../../../../../elements/Select/withSelectFetch'
import { compose } from 'recompose'
import withSort from '../../../../../elements/HOC/withSort'
import withSpinning from '../../../../../elements/HOC/withSpinning'
import CustomSelect from '../../../../../elements/Select/CustomSelect'
import omitEmpty from 'omit-empty'
import { dateVal } from '../../../../../modules/Utils'

const { MonthPicker } = DatePicker

const FormItem = Form.Item
const Option = Select.Option
const StatusSelect = compose(
  withSelectFetch({
    dropdown: 'bank',
    name: 'status',
    cache: true,
  }),
  withSpinning,
  withSort,
)(CustomSelect)
const TypeSelect = compose(
  withSelectFetch({
    dropdown: 'bank',
    name: 'type',
    cache: true,
  }),
  withSpinning,
  withSort,
)(CustomSelect)

class Bank extends Component {
  constructor(props) {
    super(props)
    this.api = new Employees()
    this.banksAPI = new Banks()
    this.auth = new Authentication()
    this.key = props.employee._key
    this.state = {
      error: { message: '', type: '', key: '' },
      counter: 0,
      file: '',
      updated: false,
      fetching: false,
      loading: false,
      removing: false,
      ibanRequired: get(props, 'bank.currency') === 'EUR',
      member: props.member,
      bank: props.bank,
      employee: props.employee,
      fileList: [],
    }
  }

  handleSubmit = e => {
    e.preventDefault()
    this.props.form.validateFieldsAndScroll(async (err, values) => {
      if (!err) {
        this.setState({ updating: true })
        const updatedBank = { ...values }
        get(updatedBank, 'card.expiry') &&
          set(updatedBank, 'card.expiry', updatedBank.card.expiry.format('YYYY/MM'))
        let bank = Object.assign({}, omit(this.state.bank, ['_key']), updatedBank, {
          file: this.state.file,
          owner: this.props.member._id,
        })
        bank = omitEmpty(bank)
        try {
          if (this.props.type === 'edit') {
            let results = await this.banksAPI.update(omit(bank, ['owner']))
            results && message.success('Updated !')
            this.setState({ updating: false, updated: true, bank: results })
          } else if (this.props.type === 'new') {
            let results = await this.banksAPI.create(bank)
            results && message.success('Created !')
            this.setState({ updating: false, bank: results })
            this.props.handleCancel(true)
          }
        } catch (error) {
          this.setState({ updating: false })

          message.error(error.errorMessage)
        }
      }
    })
  }

  handleRemove = async () => {
    this.setState({ removing: true })
    try {
      let results = await this.banksAPI.remove(pick(this.state.bank, ['_key', '_rev', '_id']))
      results && message.success('Removed !')
      this.props.handleCancel(true)
      this.setState({ removing: false })
    } catch (error) {
      this.setState({ removing: false })
      message.error(error.errorMessage)
    }
  }
  handleChangeCurrency = value => {
    this.setState(
      {
        ibanRequired: value === 'EUR',
      },
      () => {
        this.props.form.validateFields(['iban'], { force: true })
      },
    )
  }

  render() {
    const formItemLayout = {
      labelCol: {
        xs: { span: 24 },
        sm: { span: 7 },
      },
      wrapperCol: {
        xs: { span: 24 },
        sm: { span: 16 },
      },
    }
    const { getFieldDecorator } = this.props.form
    const { type, employee, handleCancel } = this.props
    const { bank, ibanRequired } = this.state
    return (
      <Form layout="horizontal">
        <Row>
          <Col span={12}>
            <FormItem label="Type" {...formItemLayout}>
              {getFieldDecorator('type', {
                initialValue: get(bank, 'type'),
              })(<TypeSelect />)}
            </FormItem>
          </Col>
          <Col span={12}>
            <FormItem label="Status" {...formItemLayout}>
              {getFieldDecorator('status', {
                initialValue: get(bank, 'status'),
                rules: [
                  {
                    required: true,
                    message: "Status can't be empty ",
                  },
                ],
              })(<StatusSelect />)}
            </FormItem>
          </Col>
        </Row>
        <Row style={{ paddingBottom: '10px', paddingTop: '10px' }}>
          <h3 style={{ color: 'rgb(43,187,143' }}>BENEFICARY DETAILS</h3>
        </Row>
        <Row>
          <Col span={12}>
            <FormItem label="Account Name" {...formItemLayout}>
              {getFieldDecorator('accname', {
                initialValue: get(bank, 'accname'),
                rules: [
                  {
                    required: true,
                    message: "Account Name can't be empty ",
                  },
                ],
              })(<Input placeholder="Account Name" />)}
            </FormItem>
          </Col>
          <Col span={12}>
            <FormItem label="Nickname" {...formItemLayout}>
              {getFieldDecorator('nickname', {
                initialValue: get(bank, 'nickname'),
                rules: [
                  {
                    required: true,
                    message: "Nickname Name can't be empty ",
                  },
                ],
              })(<Input placeholder="Nickname" />)}
            </FormItem>
          </Col>
        </Row>
        <Row>
          <Col span={12}>
            <FormItem label="Account Number" {...formItemLayout}>
              {getFieldDecorator('number', {
                initialValue: get(bank, 'number'),
                rules: [
                  this.props.form.getFieldValue('type') !== 'Card' && {
                    required: true,
                    message: "Account Number can't be empty ",
                  },
                ],
              })(<Input placeholder="Account Number" />)}
            </FormItem>
          </Col>
          <Col span={12}>
            <FormItem label="Currency" {...formItemLayout}>
              {getFieldDecorator('currency', {
                initialValue: get(bank, 'currency'),
                rules: [
                  {
                    required: true,
                    message: "Currency can't be empty ",
                  },
                ],
              })(<CurrencySelect onChange={this.handleChangeCurrency} />)}
            </FormItem>
          </Col>
        </Row>
        {this.props.form.getFieldValue('type') === 'Card' && (
          <Row>
            <Col span={12}>
              <FormItem label="Card Number" {...formItemLayout}>
                {getFieldDecorator('card.number', {
                  initialValue: get(bank, 'card.number'),
                  rules: [
                    {
                      required: true,
                      message: "Card Number can't be empty ",
                    },
                  ],
                })(<Input placeholder="Card Number" />)}
              </FormItem>
            </Col>
            <Col span={12}>
              <FormItem label="Card Expiry" {...formItemLayout}>
                {getFieldDecorator('card.expiry', {
                  initialValue: dateVal(bank, 'card.expiry'),
                  rules: [
                    {
                      required: true,
                      message: "Card Expiry can't be empty ",
                    },
                  ],
                })(<MonthPicker format={'YYYY/MM'} />)}
              </FormItem>
            </Col>
          </Row>
        )}
        <Row>
          <Col span={12}>
            <FormItem label="IBAN" {...formItemLayout}>
              {getFieldDecorator('iban', {
                initialValue: get(bank, 'iban'),
                rules: [
                  {
                    required: ibanRequired,
                    message: "IBAN can't be empty ",
                  },
                ],
              })(<Input placeholder="IBAN" />)}
            </FormItem>
          </Col>
          <Col span={12} />
        </Row>
        <Row style={{ paddingBottom: '10px', paddingTop: '10px' }}>
          <h3 style={{ color: 'rgb(43,187,143' }}>BANK DETAILS</h3>
        </Row>
        <Row>
          <Col span={12} />
          <Col span={12}>
            <FormItem label="Country" {...formItemLayout}>
              {getFieldDecorator('bank.country', {
                initialValue: get(bank, 'bank.country'),
                rules: [
                  {
                    required: true,
                    message: "Country can't be empty ",
                  },
                ],
              })(<CountrySelect />)}
            </FormItem>
          </Col>
        </Row>
        <Row>
          <Col span={12}>
            <FormItem label="Bank" {...formItemLayout}>
              {getFieldDecorator('bank.name', {
                initialValue: get(bank, 'bank.name'),
                rules: [
                  {
                    required: true,
                    message: "Bank Name can't be empty ",
                  },
                ],
              })(<Input placeholder="Bank" />)}
            </FormItem>
          </Col>
          <Col span={12}>
            <FormItem label="Branch" {...formItemLayout}>
              {getFieldDecorator('bank.branch', {
                initialValue: get(bank, 'bank.branch'),
              })(<Input placeholder="Branch" />)}
            </FormItem>
          </Col>
        </Row>
        <Row>
          <Col span={12}>
            <FormItem label="SWIFT Code" {...formItemLayout}>
              {getFieldDecorator('bank.swift', {
                initialValue: get(bank, 'bank.swift'),
                rules: [
                  {
                    required: true,
                    message: "SWIFT Code can't be empty ",
                  },
                ],
              })(<Input placeholder="SWIFT Code" />)}
            </FormItem>
          </Col>
          <Col span={12}>
            <FormItem label="Branch Code" {...formItemLayout}>
              {getFieldDecorator('bank.code', {
                initialValue: get(bank, 'bank.code'),
              })(<Input placeholder="Branch Code" />)}
            </FormItem>
          </Col>
          <Col span={12}>
            <FormItem label="BSB Code" {...formItemLayout}>
              {getFieldDecorator('bank.bsb', {
                initialValue: get(bank, 'bank.bsb'),
              })(<Input placeholder="BSB #" />)}
            </FormItem>
          </Col>
        </Row>
        <Row>
          <Col span={24}>
            <FormItem label="Address" {...formItemLayout}>
              {getFieldDecorator('bank.address', {
                initialValue: get(bank, 'bank.address'),
                rules: [
                  {
                    required: true,
                    message: "Address  can't be empty ",
                  },
                ],
              })(<Input placeholder="Address" />)}
            </FormItem>
          </Col>
        </Row>
        <Row style={{ paddingBottom: '10px', paddingTop: '10px' }}>
          <h3 style={{ color: 'rgb(43,187,143' }}>INTERMEDIARY BANK DETAILS</h3>
        </Row>
        <Row>
          <Col span={12}>
            <FormItem label="Bank Name" {...formItemLayout}>
              {getFieldDecorator('ibank.name', {
                initialValue: get(bank, 'ibank.nam'),
              })(<Input placeholder="Bank Name" />)}
            </FormItem>
          </Col>
          <Col span={12}>
            <FormItem label="Branch" {...formItemLayout}>
              {getFieldDecorator('ibank.branch', {
                initialValue: get(bank, 'ibank.branch'),
              })(<Input placeholder="Branch" />)}
            </FormItem>
          </Col>
        </Row>
        <Row>
          <Col span={12}>
            <FormItem label="SWIFT Code" {...formItemLayout}>
              {getFieldDecorator('ibank.swift', {
                initialValue: get(bank, 'ibank.swift'),
              })(<Input placeholder="SWIFT Code" />)}
            </FormItem>
          </Col>
        </Row>
        <Row>
          <Col span={24}>
            <FormItem label="Address" {...formItemLayout}>
              {getFieldDecorator('ibank.address', {
                initialValue: get(bank, 'ibank.address'),
              })(<Input placeholder="Address" />)}
            </FormItem>
          </Col>
        </Row>
        <Row>
          <Upload
            name="upload"
            multiple={false}
            action={`${streamUrl}files/`}
            fileList={this.state.fileList}
            data={{
              meta: JSON.stringify({
                folder: `employees/${employee._key}`,
                subFolder: `banks/${get(bank, '_key')}`,
                timestamp: moment(),
                category: 'banks',
              }),
            }}
            onChange={info => {
              let fileList = info.fileList
              if (info.file.status === 'done') {
                this.setState({
                  file: info.file.response[0]._key,
                  fileList: [fileList.pop()],
                })
              } else this.setState({ fileList })
            }}
            headers={{ authorization: `Bearer ${this.auth.getAccessToken()}` }}>
            <Button>
              <Icon type="upload" /> Upload New File
            </Button>
          </Upload>
        </Row>
        <Row>
          {type !== 'view' && (
            <Col span={24} style={{ textAlign: 'right' }}>
              <Button loading={this.state.updating} type="primary" onClick={this.handleSubmit}>
                {type === 'edit' ? 'Update' : 'Create'}
              </Button>
              <Popconfirm
                title="Are you sure Remove this Bank Details?"
                onConfirm={this.handleRemove}
                okText="Yes"
                cancelText="No">
                {type === 'edit' && (
                  <Button loading={this.state.removing} type="danger" style={{ marginLeft: 8 }}>
                    Remove
                  </Button>
                )}
              </Popconfirm>
            </Col>
          )}
        </Row>
      </Form>
    )
  }
}

const WrappedBankForm = Form.create()(Bank)

export default WrappedBankForm
